/* Project Import will be here */
import { types as sessionTypes } from "./session";
import { getDMSUserIdentity, updateFcmTokenApi } from "services/common";
import { getSecurityKeyGenerationApi } from "services/dms/dmsPayment";
import { types as commonTypes, showMsgFromJson } from "reducers/common";
import { getErrorObject, errorToast } from "utilities/utils";
import Constants from "utilities/appConstants";
import { ISecurityKeyGenerationParams } from "models/dmsPaymentModels";
/* Project Import will be here */

export const types = {
  UPDATE_WHOLESALER: "localStore/UPDATE_WHOLESALER",
  UPDATE_DEFAULT_LANG: "localStore/UPDATE_DEFAULT_LANG",
  UPDATE_DMS_SECURITY_TOKEN: "localStore/UPDATE_DMS_SECURITY_TOKEN",
  UPDATE_FCM_TOKEN: "localStore/UPDATE_FCM_TOKEN"
};

const { languages } = window;

const initialState = {
  token: null,
  user: null,
  selectedWholesaler: null,
  defaultLang: languages[0]["code"],
  dmsSecurityTokenKey: null,
  fcmToken: null
};

export const localStore = (state = initialState, action) => {
  switch (action.type) {
    case sessionTypes.LOGIN_SUCCESS: {
      const { token, user } = action.payload;
      return { ...state, user, token };
    }

    case sessionTypes.SIGN_UP_SUCCESS: {
      const { token } = action.payload;
      return { ...state, token };
    }

    case sessionTypes.LOG_OUT:
      return initialState;

    case types.UPDATE_WHOLESALER:
      return {
        ...state,
        selectedWholesaler: action.payload.wholeSaler,
        user: {
          ...state.user,
          distributorid: action.payload.wholeSaler.dId
        }
      };

    case types.UPDATE_DEFAULT_LANG:
      return {
        ...state,
        defaultLang: action.payload.lang
      };

    case types.UPDATE_DMS_SECURITY_TOKEN:
      return {
        ...state,
        dmsSecurityTokenKey: action.payload.dmsSecurityTokenKey
      };

    case types.UPDATE_FCM_TOKEN:
      return {
        ...state,
        fcmToken: action.payload.fcmToken
      };

    default:
      return state;
  }
};

/* upload wholesaler data */
export const updateLocalStoreWholesaler = (wholeSaler) => {
  return async (dispatch, getState) => {
    dispatch({
      type: types.UPDATE_WHOLESALER,
      payload: { wholeSaler }
    });
  }
};

/* Update application default language */
export const updateDefaultLanguage = ({ lang }) => {
  return {
    type: types.UPDATE_DEFAULT_LANG,
    payload: { lang }
  };
};

/* Update firebase push notification FCM token */
export const updateFcmToken = (token) => {
  return async (dispatch, getState) => {
    try {
      /* update the FCM token in local store reducer */
      dispatch({
        type: types.UPDATE_FCM_TOKEN,
        payload: { fcmToken: token }
      });

      /* Hit API to update the FCM token against the retailer */
      await updateFcmTokenApi(token);
    }
    catch (error) {
      /* Extract the error message and error code from the response object */
      const { message, errorCode } = getErrorObject(error);

      /* If error code is exist show the error code message or show the error message returned by the API request */
      if (errorCode !== "")
        dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
      else
        errorToast({ content: message });
    }
  }
};

/* Only call this module when the payment data is from DMS server */
export const getDMSAccessKey = () => {
  return async (dispatch, getState) => {
    try {
      /* Check for token already exist */
      if (getState().localStore.dmsSecurityTokenKey === null) {
        await dispatch({
          type: commonTypes.DMS_REQUEST_INPROGRESS
        });

        /* Get the UserIdentity from RA API to make request to DMS API */
        const raResponse = await getDMSUserIdentity();

        /* Make DMS API request to get the access token using UserIdentity */
        const requestParam: ISecurityKeyGenerationParams = {
          UserIdentity: raResponse.data.Data
        };

        const dmsResponse = await getSecurityKeyGenerationApi(requestParam);
        const token = dmsResponse.headers.security_token_key;

        dispatch({
          type: types.UPDATE_DMS_SECURITY_TOKEN,
          payload: { dmsSecurityTokenKey: token }
        });

        dispatch({ type: commonTypes.DMS_API_SUCCESS });
      }
    }
    catch (error) {
      /* Extract the error message and error code from the response object */
      const { errorCode } = getErrorObject(error);

      dispatch({ type: commonTypes.DMS_API_ERROR });

      /* If error code is exist show the error code message or show the error message returned by the API request */
      const messageKey = errorCode !== "" ? errorCode : "dmsAuthenticationError";
      dispatch(showMsgFromJson(`common.alerts.error.${messageKey}`, Constants.ERROR));
    }
  }
}
